/**
 * Viewport breakpoints used to drive responsive rendering across the
 * admin surface. The numbers are deliberately coarse — three buckets
 * are enough to express every layout choice this app needs to make:
 *
 *   - phone (< 640): bottom tab navigation, single-pane lists, stacked
 *     form rows, sticky bottom action bars, 48-px touch targets.
 *   - tablet (640..1023): sidebar navigation, single-pane lists (master
 *     and detail are too cramped side-by-side at this width once the
 *     240-px sidebar is subtracted), top-toolbar actions.
 *   - desktop (>= 1024): the existing layout — sidebar + master/detail
 *     SplitPane + two-column form rows + top-toolbar actions.
 *
 * Components consume these via `useViewport()` rather than reading the
 * raw width, so the threshold logic lives in exactly one place.
 */
export const breakpoints = {
    phone: 640,
    tablet: 1024,
} as const;

export type BreakpointKey = keyof typeof breakpoints;
